import styled from "styled-components";
import { H1 } from "components/atoms/text";
import Form from "components/templates/signUp/Form";

// 베타회원가입 페이지
const BetaSignUp = () => {
  return (
    <Container>
      <H1 className="text-primary-active md:mb-10">베타서비스 신청하기</H1>
      <p className="mb-5 text-sm break-keep">
        베타테스트 사용자로 신청해 주신분께는 2023년 12월 5일부터 정식
        오픈전까지 무료로 서비스를 이용 하실수 있습니다.
      </p>
      <Form />
    </Container>
  );
};

const Container = styled.div`
  max-width: 912px;
  margin: 0 auto;
  padding: 60px 16px 100px;

  @media (max-width: 767px) {
    padding: 40px 16px 80px;
  }
`;

export default BetaSignUp;
